export default __webpack_public_path__ + "static/media/category-img.0bbcdeb4.svg";